<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <BaseProgressBar v-if="loading" v-bind="progressBar"
      >Carregando permissões...</BaseProgressBar
    >
    <p v-else-if="!hasPermissoes" class="flow-text center-align">
      Ainda não há permissões cadastradas.
    </p>
    <div v-else>
      <BaseCollection v-bind="permissaoCollection" />
      <BasePagination
        class="center"
        v-bind="pagination"
        v-on:change="onPageChange"
      />
    </div>
  </section>
</template>

<script>
import { API_URL } from "../../constants";

const PERMISSOES_SEARCH_PAGINATION_SIZE = 10;

export default {
  name: "Permissoes",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String
  },
  data() {
    return {
      loading: false,
      permissaoCollection: {
        items: []
      },
      permissoes: [],
      pagination: {
        value: 1,
        numPages: 0
      },
      progressBar: {
        useContainer: false
      }
    };
  },
  computed: {
    hasPermissoes() {
      return (this.permissaoCollection.items || []).length !== 0;
    }
  },
  created() {
    this.getPagePermissoes(0);
  },
  methods: {
    onPageChange(event) {
      this.getPagePermissoes(event - 1);
    },
    getPagePermissoes(page) {
      this.loading = true;

      this.permissaoCollection.items = [];

      this.$http
        .get(
          `${API_URL}/acesso/permissao?pagina=${page}&tamanhoPagina=${PERMISSOES_SEARCH_PAGINATION_SIZE}`
        )
        .then(response => {
          const items = response.data.elementos;
          const total = response.data.tamanhoTotal;

          this.pagination.value = page + 1;
          this.pagination.numPages = Math.ceil(
            total / PERMISSOES_SEARCH_PAGINATION_SIZE
          );

          this.permissaoCollection.items = items
            .map(item => ({ title: item.nome }))
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de permissões: ${error.message}`
          )
        )
        .finally(() => (this.loading = false));
    }
  }
};
</script>
